"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Our25YearTrajectory() {
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="159429" id="conteúdo-dos-termos" className="bg-background text-foreground py-16 md:py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-stretch">
          
          {}
          <div ref={imageRef} className={`relative rounded-xl overflow-hidden min-h-[400px] lg:min-h-[600px] shadow-xl transition-all duration-1000 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620776/img/legal-compliance-documentation.png" alt="Documentação legal e conformidade empresarial" className="absolute inset-0 w-full h-full object-cover" />
            {}
            <div className="absolute inset-0 bg-gradient-to-b from-primary/10 via-primary/30 to-primary/80 mix-blend-multiply" />
            <div className="absolute inset-0 bg-gradient-to-b from-transparent to-background/60" />
          </div>

          {}
          <div ref={contentRef} className={`bg-card/80 backdrop-blur-md border border-border rounded-xl p-8 md:p-12 lg:p-16 flex flex-col justify-center shadow-2xl transition-all duration-1000 delay-200 ease-out ${isContentVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            {}
            <div className="border-l-4 border-secondary pl-6 md:pl-8">
              <h2 className="text-4xl md:text-[40px] font-bold font-default text-primary mb-8 leading-tight tracking-tight">
                Termos e Condições
              </h2>
              
              <div className="text-[16px] font-sans text-foreground leading-[1.7] space-y-6">
                <p>
                  Bem-vindo aos nossos Termos de Uso. Este documento estabelece as diretrizes fundamentais para a utilização de nossos serviços e plataformas digitais, assegurando que todas as interações ocorram em um ambiente de total transparência, segurança jurídica e respeito mútuo.
                </p>
                <p>
                  Ao navegar em nosso portal, você manifesta sua concordância com estas normas, que abrangem desde a proteção da propriedade intelectual até as responsabilidades de conduta do usuário. Reservamo-nos o direito de atualizar estas cláusulas periodicamente para refletir novas exigências legais.
                </p>
                <p>
                  Recomendamos a leitura atenta de cada seção para compreender plenamente seus direitos e deveres. Em caso de dúvidas sobre o conteúdo aqui exposto, nossa equipe de suporte jurídico está à disposição para fornecer os esclarecimentos necessários através dos canais oficiais.
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}